import { FormlyFieldConfig } from 'ng-formly';
export const picktableFields: Array<FormlyFieldConfig> = [
    {
        key: 'name',
        type: 'input-field',
        className: 'col-md-4',
        templateOptions: {
            type: 'text',
            placeholder: 'Unique Name',
            required: true,
            label: 'Name'
        }
    },
    {
        key: 'label',
        type: 'input-field',
        className: 'col-md-4',
        templateOptions: {
            type: 'text',
            placeholder: 'Label',
            required: true,
            label: 'Label'
        }
    },
    {
        key: 'description',
        type: 'textarea-field',
        className: 'col-md-12',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: true,
            label: 'Description'
        }
    },
    {
        key: 'notes',
        type: 'input-field',
        className: 'col-md-12',
        defaultValue: "After adding Columns, please save and edit again to generate Rows (Repeated Section)",
        templateOptions: {
            type: 'text',
            label: 'Instructions',
            disabled: true
        }
    },
    {
        type: 'repeatedsection',
        key: 'columns',
        className: 'col-md-12',
        fieldArray: {
            className: 'row',
            templateOptions: {
                btnText: 'Add',
                label: 'Columns'
            },
            fieldGroup: [
                {
                    key: "name",
                    className: 'col-md-4',
                    type: 'input-field',
                    templateOptions: {
                        type: 'text',
                        placeholder: "",
                        required: true,
                        label: "Unique Name"
                    }
                },
                {
                    key: "label",
                    className: 'col-md-4',
                    type: 'input-field',
                    templateOptions: {
                        type: 'text',
                        placeholder: "",
                        required: true,
                        label: "Label"
                    }
                },
                {
                    key: 'fieldtype',
                    type: 'select-component',
                    className: 'col-md-4',
                    templateOptions: {
                        options: [{
                            label: 'Currency',
                            value: 'currency'
                        }, {
                            label: 'Date',
                            value: 'date'
                        }, {
                            label: 'Date & Time',
                            value: 'dateandtime'
                        }, {
                            label: 'Time',
                            value: 'time'
                        }, {
                            label: 'Email',
                            value: 'email'
                        }, {
                            label: 'Geolocation',
                            value: 'geolocation'
                        }, {
                            label: 'Number',
                            value: 'number'
                        }, {
                            label: 'Percent',
                            value: 'percent'
                        }, {
                            label: 'Phone',
                            value: 'phone'
                        }, {
                            label: 'Text',
                            value: 'text'
                        }, {
                            label: 'URL',
                            value: 'url'
                        }],
                        label: 'Field Type',
                        required: true,
                        placeholder: 'Select Fieldtype'
                    }
                }
            ]
        }
    },
    {
        type: 'repeatedsection',
        key: 'rows',
        className: 'col-md-12',
        fieldArray: {
            className: 'row',
            templateOptions: {
                btnText: 'Add',
                label: 'Rows'
            },
            fieldGroup: []
        }
    }

];


// WEBPACK FOOTER //
// ./src/app/shared/formfields/picktable.ts